import { Text } from '@chakra-ui/react';
import { NodeViewContent, NodeViewProps, NodeViewWrapper } from '@tiptap/react';

/**
 * React component for rendering the CalloutNode.
 * Displays a card with light green background, optional header, and child content.
 * Styling is applied via CSS in TipTapEditor.tsx to avoid double padding.
 */
export const CalloutNodeView: React.FC<NodeViewProps> = ({ node }) => {
  const header = node.attrs.header || '';

  return (
    <NodeViewWrapper as="div" data-type="callout-node">
      {header && (
        <Text fontWeight="bold" fontSize="md" mb={2}>
          {header}
        </Text>
      )}
      <NodeViewContent className="callout-content" />
    </NodeViewWrapper>
  );
};
